function isAndroid () {
  return window.navigator.userAgent.indexOf('Android') !== -1;
}

export default isAndroid;